<template>
  <BfFlex>
    <BfInput
      v-model="filters.FreeTextSearch"
      :name="t('common.search.filterBrandOrModel')"
      :placeholder="t('common.search.filterBrandOrModel')"
      style="flex: 1"
      @keyup="updateSearch"
    />
  </BfFlex>

  <div class="pedal-selection__results">
    <BfLoader v-if="loading" />
    <BfList v-if="pedalData.length > 0">
      <BfListItem
        v-for="(pedal, i) in pedalData"
        :key="i"
        :text="`${pedal.PEDAL_BRAND} ${pedal.PEDAL_MODEL}`"
        :state="
          pedal === selected ? ListItemState.Active : ListItemState.Enabled
        "
        @click="select(pedal)"
      />
    </BfList>
    <div v-else>
      <p v-if="!loading">{{ t('common.search.noResults') }}</p>
    </div>
  </div>

  <SelectionDetails v-if="selected">
    <SelectionDetailsItem
      :label="t('setup.pedal.stack')"
      :value="`${selected.PEDAL_HEIGHT} ${t('common.unit.mm')}`"
      icon="/icons/filters/pedal__stack.svg"
    />
  </SelectionDetails>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { usePedalStore } from '@/store/pedalStore'
import {
  ListItemState,
  BfLoader,
  BfList,
  BfListItem,
  BfFlex,
  BfInput,
} from '@finetic/bikefitting-ui'
import { useDebounceFn } from '@vueuse/core'
import SelectionDetails from '@/components/setup/SelectionDetails.vue'
import SelectionDetailsItem from '@/components/setup/SelectionDetailsItem.vue'

const { t } = useI18n()

const userStore = useUserStore()
const pedalStore = usePedalStore()
const { sessionId } = storeToRefs(userStore)
const { pedalData, filters } = storeToRefs(pedalStore)
const loading = ref(false)
const selected = ref()

const emit = defineEmits(['select'])

const select = (pedal: any) => {
  selected.value = pedal
  emit('select', pedal)
}

const search = () => {
  selected.value = undefined
  loading.value = true

  pedalStore.reset()
  pedalStore.retrievePedals(sessionId?.value ?? '').then(() => {
    loading.value = false
  })
}

const updateSearch = useDebounceFn(() => {
  search()
}, 300)

search()
</script>

<style lang="scss">
.pedal-selection {
  display: flex;
  height: 100%;

  &__results {
    margin-top: 1.2rem;
    border: solid 1px var(--color-dark-10);
    border-radius: 0.4rem;
    height: 32rem;
    overflow-y: auto;

    p {
      text-align: center;
      padding: 1.6rem;
      color: var(--color-dark-40);
    }
  }
}
</style>
